import React, { Component } from "react";
import { FaCircleDot } from "react-icons/fa6";
import { FaRegEdit } from "react-icons/fa";
import axios from "axios";
import DateDisplay from "./user/dateformate";
import AddCourseUploader from "./addcourseupload";


class DescribeBody extends Component {
    state = {
        isEditing: false,
        headingText: 'Effective Serialization with Python', // Initial value
        updatedtitle: '',
        course: [],
        isEditingtags: false,
        isEditingtraining_type: false,
        isEditingrepeat: false,
        isEditinginterval: false, // New state for interval editing
        isEditingduration_from: false,
        isEditingduration_to: false,
        updatedtags: '',
        updatedtraining_type: '',
        updatedrepeat: '',
        updatedinterval: '',
        updatedduration_from: '',
        updatedduration_to: '',
        data: [
            { id: 4, durationFrom: '2025-05-01', durationTo: '2025-05-30' },
            { id: 1, durationFrom: '2025-06-01', durationTo: '2025-06-30' },
            { id: 2, durationFrom: '2025-08-01', durationTo: '2025-08-31' },
            { id: 3, durationFrom: '2025-11-01', durationTo: '2025-11-30' },
        ]
    };

    inputRef = React.createRef();
    tagsRef = React.createRef();
    trainingTypeRef = React.createRef();
    repeatRef = React.createRef();
    intervalRef = React.createRef();
    duration_fromRef = React.createRef();
    duration_toRef = React.createRef();


    //   this is for getting the api content 


    componentDidMount() {
        this.fetchCourses();
    }
    componentDidUpdate(prevProps) {
        if (this.props.course_id !== prevProps.course_id) {
            this.fetchCourses();
        }
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");

        try {
            const course_id = this.props.course_id
            const courseId = parseInt(course_id, 10);
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/courses/" + courseId, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ course: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/"; 
              } else {
                console.error("Error fetching data:", error);
              }
        }
    };

    //   and it end here









    // starting her for the header of the course


    handleEditClick = () => {
        this.setState({
            isEditing: true,
            updatedtitle: this.state.course.title // Initialize updatedHeadingText with current headingText 
        }, () => {
            if (this.inputRef.current) {
                this.inputRef.current.focus();
            }
        });
    };

    handleInputChanges = (event) => {
        this.setState({ updatedtitle: event.target.value });
    };

    handleBlur = () => {
        this.submitChanges("title");
    };

    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.submitChanges("title");
        }
    };




    //   this is the sending the new header to the api 

    handleSelectChange = (e, field) => {
        this.setState({ [`updated${field}`]: e.target.value });
    };

    handleInputChange = (event, field) => { // For input fields
        this.setState({ [`updated${field}`]: event.target.value });

    };

    // Toggle editing for other fields
    toggleEditing = (field) => {
        this.setState({
            [`isEditing${field}`]: true,
            [`updated${field}`]: this.state.course[field],
        });
    };








    // the submit to change the header is this one 




    submitChanges = (field) => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        const courseId = parseInt(course_id, 10);
        let updatedvalue = this.state[`updated${field}`];

        if (field === 'duration_from' || field === 'duration_to') {
            if (updatedvalue) { // Check if updatedvalue is not empty
                const dateParts = updatedvalue.split('-');
                if (dateParts.length === 3) {
                    const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                    updatedvalue = formattedDate; // Update the local variable
                } else {
                    console.error("Invalid date format:", updatedvalue);
                    // Handle invalid date format, perhaps show an error message
                    return; // Stop further execution
                }
            }
        }

        // Send the updatedHeadingText to your API here
        fetch(`https://api.geoinfoacademy.com/api/tutor/courses/${courseId}/`, {
            method: 'PATCH', // Assuming you're updating the existing heading
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ [field]: updatedvalue })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                // Update headingText with the successfully updated value
                this.fetchCourses();  // <--- This is the crucial change

                this.setState({
                    isEditing: false,
                    updatedtitle: '',
                    isEditingtags: false,
                    isEditingtraining_type: false,
                    isEditingRepeat: false,
                    isEditinginterval: false, // New state for interval editing
                    isEditingduration_from: false,
                    isEditingduration_to: false,
                    updatedtags: '',
                    updatedtraining_type: '',
                    updatedrepeat: '',
                    updatedinterval: '',
                    updatedduration_from: '',
                    updatedduration_to: '',
                });
                console.log('Course updated successfully:', data);
            })
            .catch(error => {
                console.error('There has been a problem with your fetch operation:', error);
            });

        this.setState({ isEditing: false });
    };








    // payment sector





    handlePayForCourse = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            window.location.href = `/tutor_description/${course_id}/paymentverify`; // Navigate if already logged in
        } else {
            localStorage.setItem('redirectCourseId', course_id); // Store course ID
            window.location.href = '/Admin_login'; // Redirect to login
        }


    };


    handleSavedCourse = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            try {
                const response = await axios.post(
                    `https://api.geoinfoacademy.com/api/saved-courses/`,
                    {
                        course_id: course_id, // Place course_id in the request body
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                console.log(response.data.message)
                this.fetchCourses()
                // Navigate if already logged in

            }
            catch (error) {
                console.error("Error initiating payment:", error);
            }
        } else {
            localStorage.setItem('redirectCourseId', course_id); // Store course ID
            window.location.href = '/login'; // Redirect to login
        }
    };


    handleUnSavedCourse = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            try {
                const response = await axios.post(
                    `https://api.geoinfoacademy.com/api/unsave/`,
                    {
                        course_id: course_id, // Place course_id in the request body
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                console.log(response.data.message)
                this.fetchCourses()
                // Navigate if already logged in

            }
            catch (error) {
                console.error("Error initiating payment:", error);

            }
        } else {
            localStorage.setItem('redirectCourseId', course_id); // Store course ID
            window.location.href = '/login'; // Redirect to login
        }
    };



    handleAddCourses = () => {
        const formcontainer = document.querySelector(".dash_add_course_cover")
        formcontainer.style.display = "flex"
    }

    render() {
        const course = this.state.course
        const { course_id } = this.props
        return (
            <div className="dash_description_body" >
                <img src={course.thumbnail} alt={"course image" + course.id} className="descrip_image" />
                <div className="content">
                    <div className="title">
                        {this.state.isEditing ? (
                            <input
                                type="text"
                                ref={this.inputRef}
                                value={this.state.updatedtitle} // Use updatedHeadingText for input
                                onChange={this.handleInputChanges}
                                onBlur={this.handleBlur}
                                onKeyDown={this.handleKeyDown}
                            />
                        ) : (
                            <h2>{course.title}<button className="edit" onClick={this.handleEditClick}><FaRegEdit /></button></h2>
                        )}

                    </div>
                    <p>
                        {this.state.isEditingtags ? (
                            <select name="courseTag" id='courseTag' value={this.state.updatedtags} onChange={(e) => this.handleSelectChange(e, 'tags')} ref={this.tagsRef} onBlur={() => this.submitChanges('tags')} >
                                <option value="Beginner">Beginner</option>
                                <option value="Intermediate">Intermediate</option>
                                <option value="Advance">Advance</option>
                                <option value="Professional">Professional</option>
                                <option value="Beginner to Intermediate">Beginner to Intermediate</option>
                                <option value="Beginner to Advance">Beginner to Advance</option>
                                <option value="Beginner to Professional">Beginner to Professional</option>
                            </select>
                        ) : (
                            <span><button className="edit" onClick={() => this.toggleEditing('tags')}><FaRegEdit /></button>{course.tags} </span>
                        )}<FaCircleDot />



                        {this.state.isEditingtraining_type ? (
                            <select name="trainingType" id='trainingType' value={this.state.updatedtraining_type} onChange={(e) => this.handleSelectChange(e, 'training_type')} ref={this.trainingTypeRef} onBlur={() => this.submitChanges('training_type')} >
                                <option value="Online Prerecorded">Online Prerecorded</option>
                                <option value="Online Live with Facilitator">Online Live with Facilitator</option>
                                <option value="General Physical Class">General Physical Class</option>
                                <option value="Physical Private Class">Physical Private Class</option>
                            </select>
                        ) : (
                            <span> <button className="edit" onClick={() => this.toggleEditing('training_type')}><FaRegEdit /></button>{course.training_type}</span>
                        )} <FaCircleDot />


                        {/* {course.repeat && course.interval ? (
                        <span>
                            {this.state.isEditingrepeat ? (
                                <select name="repeat" id='repeat' value={this.state.updatedrepeat} onChange={(e) => this.handleSelectChange(e, 'repeat')} ref={this.repeatRef} onBlur={() => this.submitChanges('repeat')}>
                                    <option value="">Select Repeat Type</option>
                                    <option value="Every Year">Every Year</option>
                                    <option value="Every Month">Every Month</option>
                                </select>
                            ) : (
                                <span><button className="edit" onClick={() => this.toggleEditing('repeat')}><FaRegEdit /></button>{course.repeat} </span>
                            )}
                        </span>*/}
                        


                        {/*Interval */}
                        {/* {this.state.isEditinginterval ? (
                                <input
                                    type="text"
                                    value={this.state.updatedinterval}
                                    onChange={(e) => this.handleInputChange(e, 'interval')}
                                    ref={this.intervalRef}
                                    onBlur={() => this.submitChanges('interval')}
                                    onKeyDown={() => this.submitChanges('interval')}
                                />
                            ) : (
                                <span><button className="edit" onClick={() => this.toggleEditing('interval')}><FaRegEdit /></button>{course.interval}</span>
                            )}
                        </span>
                        ) : ( */}




                        {/* <span>
                                {this.state.isEditingduration_from ? (

                                    <input
                                        type="date"
                                        value={this.state.updatedduration_from}
                                        onChange={(e) => this.handleInputChange(e, 'duration_from')}
                                        ref={this.duration_fromRef}
                                        onBlur={() => this.submitChanges('duration_from')}
                                        onKeyDown={() => this.submitChanges('duration_from')}
                                    />
                                ) : (<span><button className="edit" onClick={() => this.toggleEditing('duration_from')}><FaRegEdit /></button> From {course.duration_from}</span>)}
                                {this.state.isEditingduration_to ? (
                                    <input
                                        type="date"
                                        value={this.state.updatedduration_to}
                                        onChange={(e) => this.handleInputChange(e, 'duration_to')}
                                        ref={this.duration_toRef}
                                        onBlur={() => this.submitChanges('duration_to')}
                                        onKeyDown={() => this.submitChanges('duration_to')}
                                    />
                                ) : (<span><button className="edit" onClick={() => this.toggleEditing('duration_to')}><FaRegEdit /></button> To {course.duration_to}</span>)}
                            </span>)} */}
                        {/* <span>{course.repeat}</span>   <FaCircleDot />*/}
                        <span><DateDisplay data={course.duration} /> </span>
                    </p>
                    <p></p>
                    <button className="direct first" onClick={this.handlePayForCourse}>Pay For Course</button>
                    {course.saved ? <button className="direct" onClick={this.handleUnSavedCourse}>Remove From Library</button> :
                        <button className="direct" onClick={this.handleSavedCourse}>Save To Library</button>}
                    <button className="direct" onClick={this.handleAddCourses}>Update Course</button>
                </div>
                <AddCourseUploader onCourseAdded={this.fetchCourses} courseId={course_id} />
            </div>
        )
    }
}

export default DescribeBody